import { useQuery } from "react-query";
import { techCardsAPI } from "src/shared/api/techCardsAPI";

export const useFetchGetTechCards = (options) => {
  const { token, name } = options || {};
  const query = useQuery(
    ["tech_cards", token, name],
    async () => {
      console.log("Fetching tech cards with token:", token, "name:", name);
      const response = await techCardsAPI.getItems({ token, name, limit: 500 });
      console.log("API response:", response.data);
      return response.data.result || response.data || [];
    },
    {
      refetchOnWindowFocus: false,
      enabled: !!token,
      retry: 1,
      refetchInterval: false,
      staleTime: Infinity,  
      cacheTime: Infinity,  
    }
  );
  return query;
};